module.exports = __webpack_public_path__ + "static/media/bal.5297e421.png";